var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_iframe"},[_c('header-principal'),_c('iframe',{ref:"iframe",staticStyle:{"width":"100%","height":"99vh","border":"0","overflow":"hidden"},attrs:{"src":_vm.urlbSales+'?v='+_vm.version},on:{"load":_vm.sendMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }